import React from 'react';

import {
  Container,
  SearchFacets,
  SearchSorting,
} from '@uncinc/uncinc-react-kitchen-sink';

import { useTranslation } from 'react-i18next';

import {
  SearchItem as SearchItemComponent,
} from '../../../components';

import * as query from './query.gql';
import { ChipFacet } from '../../../components/SearchKit/ChipFacet';

import './style.scss';
import SearchLoadMore from '../../../components/SearchKit/SearchLoadMore';
import SearchKitVNL from '../../../components/SearchKit';
import { SelectFacet } from '../../../components/SearchKit/SelectFacet';
import SearchResults from '../../../components/SearchKit/SearchResults';

const SearchItem = ({ item }) => {
  return <SearchItemComponent item={item} type="news" includeDate />;
};

const SearchHeader = ({ data }) => {
  return (
    <span />
  );
};

const ParagraphNewsOverview = ({ entity }) => {
  const { t } = useTranslation();
  const filters = [
    {
      identifier: 'field_article_type_name',
      value: 'Nieuwsbericht',
    },
  ];

  return (
    <div className="Paragraph ParagraphNewsOverview">
      <Container>
        <SearchKitVNL
          query={query}
          pageSize={15}
          defaultFilters={filters}
          defaultSorting="created"
        >
          {
            (data, loading) => (
              <>
                {data && (
                  <div className="Search__results">
                    <div className="Search__results__filters__wrapper">
                      <div className="Search__results__filters">
                        <div className="Search__results__filters__items">
                          <span>Filter</span>
                          <SearchFacets data={data.news} loading={loading} facets={[ChipFacet, SelectFacet]} />
                        </div>
                        <div className="Search__results__filters__sorting">
                          <span>{t('general.sort')}</span>
                          <SearchSorting data={data.news} loading={loading} />
                        </div>
                      </div>
                      <div className="total-count minimized">
                        {data.news.results.summary.total} {t('general.search_results')}
                      </div>
                    </div>
                    <div className="row">
                      <SearchResults
                        data={data.news}
                        renderItem={SearchItem}
                        renderHeader={SearchHeader}
                        appendResults
                      />
                      <div className="col-12">
                        <SearchLoadMore
                          data={data.news}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </>
            )
          }
        </SearchKitVNL>
      </Container>
    </div>
  );
};

export default ParagraphNewsOverview;
